import CircleWarningIcon from '@assets/icons/circle-warning.svg';
import i18n from '@/utils/i18n';
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from '@/experiences/sales-portal/components/button';
import { createStyles } from '@/contexts/theme-context';
import { EmptyState } from '@experiences/components/empty-state';

interface OrderEntryCheckoutSummaryErrorStateProps {
  description?: string;
  loading?: boolean;
  onPress: () => void;
  title?: string;
}

export const OrderEntryCheckoutSummaryErrorState: React.FC<
  OrderEntryCheckoutSummaryErrorStateProps
> = ({
  description = i18n.t('sales_portal.checkout_panel.summary.error.description'),
  loading = false,
  onPress,
  title = i18n.t('sales_portal.checkout_panel.summary.error.title'),
}) => {
  const [styles, theme] = useStyles();

  return (
    <EmptyState
      bottomElement={
        <Button
          accessibilityLabel={i18n.t('sales_portal.checkout_panel.reload')}
          disabled={loading}
          loading={loading}
          onPress={onPress}
          size={ButtonSize.Small}
          style={styles.button}
          variant={ButtonVariant.Secondary}
        >
          {i18n.t('sales_portal.checkout_panel.reload')}
        </Button>
      }
      description={description}
      iconElement={<CircleWarningIcon stroke={theme.sk.color.icon.primary} />}
      title={title}
    />
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    paddingHorizontal: theme.sk.spacing.spaceMedium,
  },
}));
